export enum AccessorialAllocationLevelEnum {
  LoadLevel = 1,
  StopLevel = 2,
}
